import callAPiBase from './base';

const walletApi = {
  walletHistory: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/walletHistory',
      method: 'GET',
      useToken: true,
      title: 'Wallet - History',
      params,
    }),
};

export { walletApi };
export default walletApi;
